import React from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/master/faculties/createFacultyContainer';
import { actions } from '../../../redux/master/faculties';

export default function () {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
